import { render, staticRenderFns } from "./MediaSelector.vue?vue&type=template&id=145cd302"
import script from "./MediaSelector.vue?vue&type=script&lang=js"
export * from "./MediaSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports